module.exports = __webpack_public_path__ + "static/pooh-v2-02-cfce4efae9907a4c04d1f48ec086d7d8.jpg";